import React from "react";
import { get } from "lodash";
import {
  ASSET_TYPES,
  XO_FLOW_TYPES,
  XO_FLOWS_CONFIGURATIONS,
} from "utils/constants";
import { formatters } from "utils/helpers";
import Status from "shared/components/Status";
import { Export } from "shared/components/Svg/Icons/Outline";

const Transaction = ({ asset }) => {
  const {
    type,
    collateral: {
      escrow: { status },
    },
    flowType = XO_FLOW_TYPES.CONVERT,
  } = asset;
  const amount = Number(
    get(asset, "amount") || get(asset.token, "balances[0].value", 0)
  );
  const { icon, mirror } = Object.values(ASSET_TYPES).find(
    (value) => value.type === type
  );
  const config = XO_FLOWS_CONFIGURATIONS[flowType];

  return (
    <div className="transaction__item">
      <div className="transaction__item--content">
        <div className={`transaction__item--icon ${config.className}`}>
          {config.icon}
        </div>
        <div className="transaction__item--main">
          <span className="transaction__type">{flowType}</span>
          <span className="transaction__amount">
            {formatters.amounts(amount, mirror)}
          </span>
        </div>
        <div className="transaction__item--currency">
          <span className="currency__icon">{icon}</span>
          <span className="currency__text">{mirror.toUpperCase()}</span>
        </div>
      </div>
      <div className="transaction__item--status">
        <Status name={status} variant="dot" size="small" />
      </div>
      <div className="transaction__item--arrow">
        <Export height={16} width={16} />
      </div>
    </div>
  );
};

export default Transaction;
